module.exports = __webpack_public_path__ + "media/images/countryrect/vc-02fb9733143e041c3be2cde48950797d.svg";